import BaseModel from "./baseModel";
import { getDownloadUrl } from "../utils/mediaHelpers";

class DownloadUrlModel extends BaseModel {
  constructor(options = {}) {
    super(options);
    this.set("contentModel", options.contentModel ?? {});
  }

  async fetch() {
    const downloadUrl = await getDownloadUrl(this.get("contentModel"));
    this.set("downloadUrl", downloadUrl);
    return Promise.resolve(this);
  }
}

export default DownloadUrlModel;
